
const lifOfferKeyUsed = {
  easterBasketSale: {
    cookieKeysUsed: ['LIF-PARAMS--EASTER-BASKET-SALE', 'LIF-SETTINGS--EasterBasketSalesSettings'],
    sessionKeysUsed: [],
    propertyKeysUsed: [
      '_is_easter_basket_free_gift',
      '_easter_basket_free_gift_threshold',
      '__easter_basket_sale',
      '_applied_offer_type',
    ],
  },
  offer1Free: {
    cookieKeysUsed: ['LIF-PARAMS--FREE_SHIRT_OFFER'],
    sessionKeysUsed: [],
    propertyKeysUsed: ['_is_free_shirt', '_applied_offer_type'],
  },
  offerFixedPrice: {
    cookieKeysUsed: ['LIF-PARAMS--FIXED_PRICE_OFFER'],
    sessionKeysUsed: [],
    propertyKeysUsed: ['__fixed_price_offer'],
  },
  offerFWP: {
    cookieKeysUsed: ['LIF-PARAMS--FWP_OFFER', 'LIF-PARAMS--FWP_Settings', 'LIF-PARAMS--FWP_Product_Handle'],
    sessionKeysUsed: [],
    // also using '_is_free_shirt', '_applied_offer_type' but deleting these keys to avoid conflict with offer=1free
    propertyKeysUsed: ['_fwp_first_product', '_fwp_second_product'], 
  },
  dynamicPriceSale: {
    cookieKeysUsed: ['LIF-PARAMS--DYNAMIC-SALE'],
    sessionKeysUsed: [],
    propertyKeysUsed: ['__dynamic_sale_tag', '__dynamic_sale_name'],
  },
  winterBundleSale: {
    cookieKeysUsed: ['LIF-PARAMS--CUSTOM-BUNDLE-SALE', 'LIF-SETTINGS--BundleSalesSettings', 'LIF-PARAM--CustomBundleSettings', 'LIF-PARAM-CustomBundle-SuccessPopupDone'],
    sessionKeysUsed: [],
    propertyKeysUsed: ['__winter_bundle_sale', '__winter_bundle_sale_fixed_price', '__is_winter_product'],
  },
  winterBundleSaleMultiple: {
    cookieKeysUsed: ['LIF-PARAMS--CUSTOM-BUNDLE-SALE-MULTIPLE', 'LIF-PARAM-CustomBundle-SuccessPopupDone'],
    sessionKeysUsed: ['LIF-PARAM--CustomBundleSettings'], // This is local storage settings
    propertyKeysUsed: ['__winter_bundle_sale', '__winter_bundle_sale_fixed_price', '__is_winter_product'],
  },
  blackFridaySale: {
    cookieKeysUsed: ['LIF-PARAMS--BLACK_FRIDAY_OFFER', 'LIF-SETTINGS--BlackFridaySalesSettings'],
    sessionKeysUsed: ['LIF-PARAMS--BlackFridaySettings'],
    propertyKeysUsed: ['__black_friday_sale'],
  },
  fwpSale: {
    cookieKeysUsed: ['LIF-PARAMS--FWP_Settings', 'LIF-PARAMS--FWP_OFFER', 'LIF-PARAMS--FWP_Product_Handle'],
    sessionKeysUsed: [],
    propertyKeysUsed: [],
  },
  buyMoreSale: {
    cookieKeysUsed: [],
    sessionKeysUsed: [],
    propertyKeysUsed: ['__buy_more_bundle_item'],
  },
  incrementalSale: {
    cookieKeysUsed: ['LIF-PARAMS--INCREAMENTAL_SALE', 'LIF-PARAM-IncrementalSaleSettings', 'LIF-PARAM-Incremental-SuccessPopupDone'],
    sessionKeysUsed: [],
    propertyKeysUsed: ['__incremental_sale'],
  }
};

const OFFER_COOKIE_KEY_NAME = 'LIF-PARAMS--FREE_SHIRT_OFFER';

const removeOfferCookieAndSessions = (removeCookieExceptKeys) => {

  const offerCookiesKeys = [];
  for (const [key, offerKeys] of Object.entries(lifOfferKeyUsed)) {
    offerCookiesKeys.push(...offerKeys.cookieKeysUsed)
  }

  const finalOfferCookiesKeys = offerCookiesKeys.filter((k) => !removeCookieExceptKeys.includes(k));

  for (let i = 0; i < finalOfferCookiesKeys.length; i += 1) {
    // console.log(`Removing cookie ${finalOfferCookiesKeys[i]}...`);
    removeLifCookie(finalOfferCookiesKeys[i]);
  }

  const offerSessionsKeys = [];
  for (const [key, offerKeys] of Object.entries(lifOfferKeyUsed)) {
    offerSessionsKeys.push(...offerKeys.sessionKeysUsed)
  }

  const finalOfferSessionsKeys = offerSessionsKeys.filter((k) => !removeCookieExceptKeys.includes(k));

  for (let i = 0; i < finalOfferSessionsKeys.length; i += 1) {
    // console.log(`Removing session ${offerSessionsKeys[i]}...`);
    window.sessionStorage.removeItem(finalOfferSessionsKeys[i]);
    window.localStorage.removeItem(finalOfferSessionsKeys[i]);
  }
};

const deactivateOtherOffersIfActive = async (
  removeCookieExceptKeys = [],
  removePropertiesExceptKeys = [],
  deleteItemsExceptKeys = [],
  pushToCart = true,
) => {
  console.log('-------------------------- Deactivate Other Offers Started -------------------------');
  removeOfferCookieAndSessions(removeCookieExceptKeys);

  const shouldBeDeleteProperties = [];
  for (const [key, offerKeys] of Object.entries(lifOfferKeyUsed)) {
    shouldBeDeleteProperties.push(...offerKeys.propertyKeysUsed)
  }

  const shouldBeDeletedItems = [
    '__is_winter_product',
    '__winter_bundle_sale',
    '_bb_upgrade_kit',
    '_bb_upgrade_shirt',
  ].filter((k) => !deleteItemsExceptKeys.includes(k));
  
  // debugger;
  const shouldBeDeletePropertiesFinal = shouldBeDeleteProperties.filter((k) => 
    !removePropertiesExceptKeys.includes(k) && 
    !shouldBeDeletedItems.includes(k)
  );

  // debugger;

  // const deleteByKeys = [];

  let needRefreshCart = false;

  // Revert cart items to original price
  const { cartItems } = Alpine.store('cart');
  console.log(cartItems);

  for (let i = 0; i < cartItems.length; i += 1) {
    const { properties, original_price: originalPrice } = cartItems[i];

    // Delete absolute free product if any
    if (originalPrice === 0) {
      // Ignore to add to Temp Items
      needRefreshCart = true;
      continue;
    }

    for (let j = 0; j < shouldBeDeletePropertiesFinal.length; j += 1) {
      const property = shouldBeDeletePropertiesFinal[j];

      if (properties.attributes.hasOwnProperty(property)) {
        console.log('Deleting item property....'+property);

        delete properties.attributes[property];
        needRefreshCart = true;
      }
    }

    let shouldDeleteThisItem = false;
    for (let k = 0; k < shouldBeDeletedItems.length; k += 1) {
      const property = shouldBeDeletedItems[k];

      // console.log('Checking property: '+property);
      // console.log(properties.attributes)

      // eslint-disable-next-line no-prototype-builtins
      if (properties.attributes.hasOwnProperty(property)) {
        
        console.log('Deleting item....'+i);

        shouldDeleteThisItem = true;
        needRefreshCart = true;
      }
    }

    if (!shouldDeleteThisItem) {
      console.log('Adding item to temp....'+i);
      Alpine.store('cart').tempItems.push(cartItems[i]);
    }
  }

  if (needRefreshCart || !pushToCart) {
    console.log('Clearing cart...');
    await Alpine.store('cart').clearCart();

    if (pushToCart) {
      console.log('Pushing temp item to cart...');
      setTimeout(() => {
        Alpine.store('cart').pushTempItemsToCart(needRefreshCart);
      }, 2000); // This avoid to execute before cart is cleared
    }
  }

  console.log('------------------------- Deactivate Other Offers End ------------------------ ');

  // if (deleteByKeys.length > 0) {
  //   console.log('Deleting products...');
  //   console.log(deleteByKeys);

  //   // eslint-disable-next-line no-await-in-loop
  //   await dispatch('cart/removeItemAsync', { key: deleteByKeys }, { root: true });
  // }

  // Update cart change
  // await dispatch('cart/init', {}, { root: true });
};

const isFreeShirtOfferON = () => {
  if (getLifCookie('LIF-PARAMS-free_offer_has_been_used') == 1) {
    return false;
  }

  if (!window.__LIF__.offer_1_free_settings || !window.__LIF__.offer_1_free_settings.is_enabled) {
    return false;
  }

  const freeOfferStartTime = window.__LIF__.offer_1_free_settings.start_time;
  const freeOfferEndTime = window.__LIF__.offer_1_free_settings.end_time;

  // check start and end time
  if (!freeOfferStartTime || !freeOfferEndTime) {
    return false;
  }

  const offerStartDateTime = new Date(freeOfferStartTime);
  const offerEndDateTime = new Date(freeOfferEndTime);

  const offerStartDateTimestamp = offerStartDateTime ? offerStartDateTime.getTime() : 0;
  const offerEndDateTimestamp = offerEndDateTime ? offerEndDateTime.getTime() : 0;
  const currentTimestamp = Date.now();

  // Check if currently offer is running
  if (currentTimestamp > offerStartDateTimestamp && currentTimestamp < offerEndDateTimestamp) {
    // Offer is not running
    return true;
  }

  return false;
};

const ordinalSuffixOf = (i) => {
  const j = i % 10;
  const k = i % 100;
  if (j === 1 && k !== 11) {
    return `${i}st`;
  }
  if (j === 2 && k !== 12) {
    return `${i}nd`;
  }
  if (j === 3 && k !== 13) {
    return `${i}rd`;
  }
  return `${i}th`;
}

const getCalenderDateNumbers = () => {
  const numbers = [];
  for (let i = 1; i <= 31; i += 1) {
    numbers.push({
      number: i,
      text: ordinalSuffixOf(i),
    });
  }
  return numbers;
};

const capitalizeWords = (str) => {
  return str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
}

const isAnyOfferIsActive = () => {
  for (const [key, offerKeys] of Object.entries(lifOfferKeyUsed)) {
    const activeSale = getLifCookie(offerKeys.cookieKeysUsed[0]);

    if (activeSale) {
      console.log(`"${offerKeys.cookieKeysUsed[0]}" Offer is active`);
      return true;
    }
  }

  return false;
}